export const GmailHowItWorks: React.FC = () => {
  return (
    <div>
      Connect your accounts to easily drafts and send emails through your Gmail account. Leverage client emails for meeting prep and insights, capture more
      tasks, and get answers to client-related questions in seconds from your Gmail. Automate inbound and outbound emails with Zocks Ultimate.
    </div>
  )
}
